module.exports = __webpack_public_path__ + "static/img/code.5e033ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/code.jpg
// module id = pumF
// module chunks = 0